Vue.component('the-menu', {
    data() {
        return {
            opened: false,
            active: '/',
            accordionOpened: false,
        };
    },
    props: {
        links: Array,
        accordionLinks: Array,
    },
    computed: {
        white() {
            return store.state.white;
        },
    },
    methods: {
        openCallback() {
            store.dispatch('setCallbackModal', true);
        },
        openOrderCall() {
            store.dispatch('setOrderCallModal', true);
        },
        toggle() {
            this.opened = !this.opened;
        },
        close() {
            this.opened = false;
        },
        open() {
            this.opened = true;
        },
        clickOutside(e) {
            let elem = document.querySelector('.menu');
            if (!elem.contains(e.target)) {
                this.close();
            }
        },
        detectActive() {
            for (let item of this.links) {
                if (window.location.pathname.indexOf(item) == 0) {
                    this.active = item;
                }
            }
        },
        toggleCatalog() {
            this.accordionOpened = !this.accordionOpened;
        },
    },
    created() {
        document.addEventListener('click', this.clickOutside);
        window.addEventListener('hashchange', this.close);
        this.detectActive();
    },
});
